module.exports = __webpack_public_path__ + "img/2010.97c47c14.jpg";